module.exports = __webpack_public_path__ + "img/中国搜索_02.52b484bf.jpg";